import {
  ProjectBigLogo,
  ProjectLogo,
} from '~/projects/polyllm-chat/components/ProjectLogo';
import { ProjectConfigType } from '~/projects/types';

export const PROJECT_NAME = 'AI Chat';

const config: ProjectConfigType = {
  name: PROJECT_NAME,
  getLogo: () => ProjectLogo,
  getBigLogo: () => ProjectBigLogo,
  getSendIcon: () => {
    const { ReactComponent } = require('../assets/send.svg');
    return ReactComponent;
  },
  supportEmail: 'support@chatwithai.app',
  isExtensionAvailable: false,
  availableToolIds: [],
};

export default config;
